import React from "react";
import { Navigate, useLocation, useSearchParams } from "react-router-dom";

export const fromEmailParamsName = "fe";
export const linkFromEmail = "linkFromEmail";

const NavigateToLoginPage = () => {
  const [searchParams] = useSearchParams();

  const location = useLocation();

  const fromEmail = searchParams.get(fromEmailParamsName);

  if (!!fromEmail) {
    sessionStorage.setItem(linkFromEmail, `${location.pathname}${location.search}`);
  }

  return (
    <Navigate
      to="/login"
      replace
    />
  );
};

export default NavigateToLoginPage;
